module.exports = __webpack_public_path__ + "img/逆时针旋转90度2.a1e3c0da.svg";